export const getLaunchDarklyFlags = (state) => {
  return state.launchDarklyFlags;
};
